import { useNavigate, useLocation } from "react-router-dom";
import logo from "../../assets/logo.png";

import {
  FaCalendarAlt,
  FaSuitcase,
  FaList,
  FaUserClock,
  FaSignOutAlt,
  FaHistory,
  FaFileInvoiceDollar,
  FaCog
} from "react-icons/fa";

import AvailableTours from "./AvailableTours";
import MyTours from "./MyTours";
import History from "./History";
import GuideCalendar from "./GuideCalendar";
import Availability from "./Availability";
import GuideInvoices from "./GuideInvoices";
import Settings from "./Settings";

export default function GuideDesktopLayout() {

const navigate = useNavigate();
const location = useLocation();

const tab =
  location.pathname.split("/")[2] || "available";

  const menu = [

    {
      key: "available",
      label: "Available Tours",
      icon: <FaList />
    },

    {
      key: "mine",
      label: "My Tours",
      icon: <FaSuitcase />
    },

    {
      key: "history",
      label: "History",
      icon: <FaHistory />
    },

    {
      key: "invoices",
      label: "Invoices",
      icon: <FaFileInvoiceDollar />
    },

    {
      key: "calendar",
      label: "Calendar",
      icon: <FaCalendarAlt />
    },

    {
      key: "availability",
      label: "Availability",
      icon: <FaUserClock />
    },

    {
    key: "settings",
    label: "Settings",
    icon: <FaCog />
}

  ];

const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("user");

    sessionStorage.removeItem("token");
    sessionStorage.removeItem("role");
    sessionStorage.removeItem("user");

    navigate("/login");
};

  const renderContent = () => {

    switch (tab) {

      case "available":
        return <AvailableTours />;

      case "mine":
        return <MyTours />;

      case "history":
        return <History />;

      case "invoices":
        return <GuideInvoices />;

      case "calendar":
        return <GuideCalendar />;

      case "availability":
        return <Availability />;

      case "settings":
       return <Settings />;

      default:
        return <AvailableTours />;

    }

  };

  return (

    <div style={layout}>

      {/* =====================================================
          SIDEBAR
      ===================================================== */}

      <div style={sidebar}>

        {/* LOGO */}

        <div
          style={{
            textAlign: "center",
            marginBottom: "20px"
          }}
        >

          <img
  src={logo}
  alt="Paris Unscripted"
  style={{
    width: "100%",
    maxWidth: "220px",
    height: "auto",
    objectFit: "contain",
    display: "block",
    margin: "0 auto"
  }}
/>

          <p
            style={{
              fontSize: "24px",
              fontWeight: "800",
              textAlign: "center",
              marginTop: "1px",
              color: "#111827",
              letterSpacing: "1px",
              textTransform: "uppercase"
            }}
          >
            Guide Portal
          </p>

        </div>

        {/* ===================================================
            MENU
        =================================================== */}

        <div
  style={{
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    overflowX: "hidden",
    marginTop: 20,
    marginBottom: 14
  }}
>

          {menu.map((item) => {

            const isActive =
              tab === item.key;

            return (

              <div
                key={item.key}

                onClick={() =>
  navigate(`/guide/${item.key}`)
}

                style={{
                  ...navItem,

                  background: isActive
                    ? "#f3841c"
                    : "transparent",

                  color: isActive
                    ? "white"
                    : "#000000"
                }}

              >

                {item.icon}

                <span>
                  {item.label}
                </span>

              </div>

            );

          })}

        </div>

        {/* ===================================================
            LOGOUT
        =================================================== */}

        <div style={footer}>

          <div
            style={logout}

            onClick={handleLogout}

            onMouseEnter={(e) =>
              (e.currentTarget.style.background =
                "#000000")
            }

            onMouseLeave={(e) =>
              (e.currentTarget.style.background =
                "#111827")
            }

          >

            <FaSignOutAlt />

            Logout

          </div>

        </div>

      </div>

      {/* =====================================================
          MAIN CONTENT
      ===================================================== */}

      <div style={main}>

        {renderContent()}

      </div>

    </div>

  );
}

/* ============================================================
   STYLES
============================================================ */

const layout = {
  display: "flex",
  height: "100vh"
};

const sidebar = {
  width: "260px",
  height: "100vh",
  boxSizing: "border-box",
  background: "#c75028",
  color: "white",
  padding: "20px",
  display: "flex",
  flexDirection: "column",
  flexShrink: 0,
  overflow: "hidden"
};

const navItem = {
  display: "flex",
  alignItems: "center",
  gap: "10px",
  padding: "10px",
  marginBottom: "4px",
  borderRadius: "8px",
  cursor: "pointer",
  transition: "0.2s",
  color: "#000000"
};

const footer = {
  marginTop: "20px"
};

const logout = {
  display: "flex",
  alignItems: "center",
  gap: "10px",
  padding: "10px 12px",
  borderRadius: "10px",
  cursor: "pointer",
  background: "#111827",
  color: "white",
  transition: "0.2s"
};

const main = {
  flex: 1,
  padding: "25px",
  background: "#ffffff",
  overflowY: "auto"
};